import {
  Flex,
  Button,
  MicIcon,
  Animation,
  Provider,
} from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { AudioTestState } from "../../../types/Device.types";

import { useAudioMicButtonStyles } from "./AudioMicButton.styles";
import { AudioMicButtonProps } from "./AudioMicButton.types";

export const AudioMicButton: React.FC<AudioMicButtonProps> = ({
  audioTestState,
  startAudioTestCall,
}) => {
  const micButtonStyles = useAudioMicButtonStyles();
  const { t } = useTranslation();

  const visualRingProgress = {
    keyframe: {
      from: {
        strokeDasharray: "0 500",
      },
      to: {
        strokeDasharray: "500 0",
      },
    },
    duration: "10s",
    iterationCount: "infinite",
  };

  return (
    <Flex>
      <Flex
        styles={
          audioTestState === AudioTestState.STARTED
            ? micButtonStyles.middleSectionGlow
            : micButtonStyles.middleSectionDefault
        }
      />
      <Provider
        theme={{
          animations: {
            visualRingProgress,
          },
        }}
      >
        <svg
          style={micButtonStyles.circleIcon}
          xmlns="http://www.w3.org/2000/svg"
        >
          <Animation
            mountOnEnter
            appear={false}
            visible={audioTestState === AudioTestState.STARTED}
            delay="3s"
            name="visualRingProgress"
          >
            <circle
              style={micButtonStyles.audioProgressCircle}
              cx="60"
              cy="60"
              r="57"
            />
          </Animation>
          <circle
            style={micButtonStyles.micIconShadow}
            cx="60"
            cy="60"
            r="57"
          />
        </svg>
      </Provider>

      <Button
        data-testid="startAudioTestCircleIcon"
        className="quiet-button"
        aria-label={
          audioTestState === AudioTestState.STARTED
            ? t("AUDIO_TEST_STARTED_A11Y")
            : t("AUDIO_TEST_START_PROMPT_A11Y")
        }
        aria-live="polite"
        aria-disabled={audioTestState === AudioTestState.STARTED}
        styles={micButtonStyles.micButton}
        fluid
        onClick={
          audioTestState === AudioTestState.INITIATED
            ? startAudioTestCall
            : undefined
        }
        circular
        icon={<MicIcon outline size="largest" />}
        iconOnly
        inverted
      />
    </Flex>
  );
};
